"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _formatNumber = _interopRequireDefault(require("format-number"));

var _semanticUiReact = require("semantic-ui-react");

var _ucfirst = require("@seafront/ucfirst");

var _moment = _interopRequireDefault(require("../../lib/moment"));

var _Colors = require("../00_environment/Colors");

var _Element = _interopRequireDefault(require("../01_atoms/Element"));

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

var _SquaredText = _interopRequireDefault(require("../01_atoms/SquaredText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var formatPrice = function formatPrice(price) {
  return (0, _formatNumber["default"])({
    prefix: '$',
    round: 2,
    padRight: 2
  })(price);
};

var RidesListItem = function RidesListItem(_ref) {
  var id = _ref.id,
      r = _ref.ride,
      _ref$numberOfPassenge = _ref.numberOfPassengers,
      numberOfPassengers = _ref$numberOfPassenge === void 0 ? 1 : _ref$numberOfPassenge,
      _ref$onRideClick = _ref.onRideClick,
      onRideClick = _ref$onRideClick === void 0 ? function () {} : _ref$onRideClick,
      _ref$translator = _ref.translator,
      t = _ref$translator === void 0 ? function (txt) {
    return txt;
  } : _ref$translator;
  var departure = (0, _moment["default"])(r.departureTime);
  var arrival = (0, _moment["default"])(r.arrivalTime);

  var rideDuration = _moment["default"].duration(arrival.diff(departure));

  var formattedDuration = "".concat(rideDuration.days() > 0 ? " ".concat(rideDuration.days(), "d") : '').concat(rideDuration.hours(), "h").concat(rideDuration.minutes() > 0 ? " ".concat(rideDuration.minutes(), "m") : '');

  var nDaysAdded = _moment["default"].duration((0, _moment["default"])(arrival.format('YYYY-MM-DD')).diff((0, _moment["default"])(departure.format('YYYY-MM-DD')))).days();

  var d = nDaysAdded ? " (+".concat(nDaysAdded, "d)") : '';
  var dh = departure.format('HH:mm');
  var ah = arrival.format('HH:mm');
  var FormattedPrice = numberOfPassengers > 1 ? function () {
    return /*#__PURE__*/_react["default"].createElement("span", null, numberOfPassengers, "\xA0x\xA0", formatPrice(r.grossPrice));
  } : function () {
    return formatPrice(r.grossPrice);
  };
  return /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    id: id,
    key: "ride-item_".concat(r.id),
    slim: true
  }, /*#__PURE__*/_react["default"].createElement(_Element["default"], {
    slimmer: true,
    key: "ride-item-el_".concat(r.id),
    onClick: function onClick() {
      onRideClick(r);
    },
    style: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paddingBottom: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      margin: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: '#f9f9f9',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      paddingLeft: '5%',
      paddingRight: '5%',
      paddingTop: 10,
      paddingBottom: 10,
      color: 'black'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    src: r.transporter.logo,
    avatar: true,
    style: {
      marginRight: 10
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: '1'
    }
  }, (0, _ucfirst.ucfirstEachWord)(r.transporter.name)), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: '#dedede',
      fontSize: '1.5rem',
      marginLeft: 5,
      textAlign: 'right'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    style: {
      display: 'inline',
      margin: 0
    },
    name: "angle right"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingLeft: '5%',
      paddingRight: '5%',
      marginTop: 15,
      marginBottom: 10
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontSize: '1rem',
      width: '45%'
    }
  }, dh, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    name: "arrow right",
    style: {
      display: 'inline',
      marginLeft: 5
    }
  }), ah + d), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: _Colors.discreetTextColor,
      fontSize: '0.8rem',
      flex: '1'
    }
  }, formattedDuration), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    size: "mini",
    style: {
      fontWeight: 'bold',
      fontSize: '1.1rem',
      textTransform: 'none',
      textAlign: 'right'
    }
  }, /*#__PURE__*/_react["default"].createElement(FormattedPrice, null)), ' ')), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      paddingLeft: '5%',
      paddingRight: '5%',
      marginTop: 5,
      marginBottom: 10,
      color: _Colors.discreetTextColor,
      fontSize: '0.8rem'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, "".concat(t('Service'), ":"), ' ', /*#__PURE__*/_react["default"].createElement(_SquaredText["default"], {
    style: {
      fontSize: '0.6rem'
    }
  }, r ? r.busCategory || (r.apiData ? r.apiData.trp_desc : null) || '' : '')))));
};

var _default = RidesListItem;
exports["default"] = _default;